// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{margin:0}.v-main{flex:1 0 0!important;overflow:auto}.v-main__wrap{align-items:flex-start!important}.main-container .v-main__wrap{display:flex;flex-direction:column!important}.main-container .v-main__wrap>.container{flex:1;margin-bottom:7rem;margin-top:5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
